import { Command } from 'commands/Commands';

export class ChangeAddressOfficeEmail extends Command {
  type: string = 'ChangeAddressOfficeEmail';
  priority: number = 100;
}
